import React, { useState, createContext } from 'react';
import classNames from 'classnames/bind';
import { SearchPanel } from 'sections/Resources/FreightDictionary/components/SectionTerms/SearchPanel';
import { TermsListContainer } from 'sections/Resources/FreightDictionary/components/SectionTerms/TermsList/TermsListContainer';
import { TermItem } from 'sections/Resources/FreightDictionary/types';
import styles from 'sections/Resources/FreightDictionary/components/SectionTerms/SectionTerms.module.scss';

const cn = classNames.bind(styles);

export const TermsContext = createContext<any>({});

const SectionTerms = () => {
  const [ foundTerms, setFoundTerms ] = useState<TermItem[]>([]);
  const [ searchValue, setSearchValue ] = useState<string>('');
  const [ isSearchActive, setIsSearchActive ] = useState<boolean>(false);

  const contextValue = {
    foundTerms,
    setFoundTerms,
    searchValue,
    setSearchValue,
    isSearchActive,
    setIsSearchActive,
  };

  return (
    <section className={cn('terms')}>
      <div className={cn('container')}>
        <TermsContext.Provider value={contextValue}>
          <SearchPanel/>
          <TermsListContainer/>
        </TermsContext.Provider>
      </div>
    </section>
  );
};

export default SectionTerms;
